<template>
    <div class="login-vue" :style="bg">
        <div class="container">
            <p class="title">WELCOME</p>
            <div class="input-c">
                <Input prefix="ios-contact" v-model="LoginDTO.access" placeholder="用户名"  />
                <p class="error">{{accountError}}</p>
            </div>
            <div class="input-c">
                <Input type="password" v-model="LoginDTO.password" prefix="md-lock" placeholder="密码" 
                @keyup.enter.native="submit" />
                <p class="error">{{pwdError}}</p>
            </div>
            <Button :loading="isShowLoading" class="submit" type="primary" @click="submit">登陆</Button>
            <!-- <p class="account"><span @click="register">注册账号</span> | <span @click="forgetPwd">忘记密码</span></p> -->
        </div>
    </div>
</template>

<script>
    import { fetchUserData } from '@/api/index'
export default {
    name: 'login',
    data() {
        return {
            LoginDTO:{
                access: '',
                password: ''
            },
            accountError: '',
            pwdError: '',
            isShowLoading: false,
            bg: {},
        }
    },
    created() {
        this.getUrlKey(),
        this.bg.backgroundImage = 'url(' + require('../assets/imgs/bg0' + new Date().getDay() + '.jpg') + ')'
    },
    watch: {
        $route: {
            handler(route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true,
        },
    },
    methods: {
       
        register() {

        },
        forgetPwd() {

        },

             /* 获取地址栏url参数 */
    getUrlKey() {
        const url = this.$route.fullPath.split("?")[1]
    if(url){
        const kv = url.split("&")
        if(kv){
        const list = []
        for(var i=0;i<kv.length;i++){
          const mode = {}
          const value = kv[i].split("=")[1]
          mode.key =  value
          list.push(mode);
    }
    if(list.length>1){
        if(list[0].key){
        this.LoginDTO.access=list[0].key
    }
    if(list[1].key){
        this.LoginDTO.password=list[1].key
    }
    }

        }
    }
    this.submit()
},
        submit() {
            fetchUserData(this.LoginDTO).then((res) => {
                console.log(res)
                if(res.data.code===10000){
                localStorage.setItem('userImg', 'https://avatars3.githubusercontent.com/u/22117876?s=460&v=4')
                console.log(this)
                localStorage.setItem('userName', this.LoginDTO.access)
                localStorage.setItem('access', this.LoginDTO.access)
                this.isShowLoading = true
                localStorage.setItem('token', this.LoginDTO.account)
                this.$router.push({ path: this.redirect || 'home' })
                }else{
                    if(res.data.data.length<50){
                        this.pwdError = res.data.data
                    }
                    
                }
        })
            // if (this.account === 'admin' && this.pwd === 'admin') {
              
            //     // 登陆成功 设置用户信息
       
            //     // 登陆成功 假设这里是后台返回的 token
              
            // } else {
            //     if (this.account !== 'admin') {
            //         this.accountError = '账号为admin'
            //     }

            //     if (this.pwd !== 'admin') {
            //         '密码为admin'
            //     }
            // }
        },
    },
}
</script>

<style>
.login-vue {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.login-vue .container {
    background: rgba(255, 255, 255, .5);
    width: 300px;
    text-align: center;
    border-radius: 10px;
    padding: 30px;
}
.login-vue .ivu-input {
    background-color: transparent;
    color: #fff;
    outline: #fff;
    border-color: #fff;
}
.login-vue ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: rgba(255, 255, 255, .8);
}
.login-vue :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(255, 255, 255, .8);
}
.login-vue ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(255, 255, 255, .8);
}
.login-vue :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(255, 255, 255, .8);
}
.login-vue .title {
    font-size: 16px;
    margin-bottom: 20px;
}
.login-vue .input-c {
    margin: auto;
    width: 200px;
}
.login-vue .error {
    color: red;
    text-align: left;
    margin: 5px auto;
    font-size: 12px;
    padding-left: 30px;
    height: 20px;
}
.login-vue .submit {
    width: 200px;
}
.login-vue .account {
    margin-top: 30px;
}
.login-vue .account span {
    cursor: pointer;
}
.login-vue .ivu-icon {
    color: #eee;
}
.login-vue .ivu-icon-ios-close-circle {
    color: #777;
}
</style>
